var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSucursal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 11.763l2.472 1.57-.656-2.96 2.184-1.991-2.876-.261-1.124-2.788-1.124 2.788-2.876.26 2.18 1.992-.652 2.96 2.472-1.57z",
    fill: "#122549"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.888 6.667H4a2.675 2.675 0 00-2.667 2.666v17.334h29.334V15.445A6.644 6.644 0 0128 16v8h-4.28c.427-.333.76-.773.947-1.293h2.146v-.987c0-.944-.755-1.331-1.579-1.754-.13-.067-.263-.135-.394-.206L16 15.333h-4.907l-2.946 2.454H7.16c-1.093 0-1.973.88-1.973 1.973v2.947h2.146c.187.52.52.96.947 1.293H4V9.333h17.333c0-.948.198-1.85.555-2.666zM11.573 21.72c0-.813-.653-1.48-1.466-1.48-.814 0-1.48.667-1.48 1.48s.666 1.467 1.48 1.467c.813 0 1.466-.654 1.466-1.467zm0-4.907l-2.2 1.96H19.44l-3.933-1.96h-3.934zM20.067 24a3.203 3.203 0 01-.947-1.293h-6.24c-.213.52-.533.96-.947 1.293h8.134zm1.826-3.76c-.813 0-1.466.667-1.466 1.48s.653 1.48 1.466 1.467c.814 0 1.48-.654 1.48-1.467 0-.813-.666-1.48-1.48-1.48z",
    fill: "#122549"
  })));
}
export default SvgSucursal;